(function ($) {
	$(document).on('click', '.faq-title', function () {
		//Expand or collapse this panel
		$(this).parent().find('.faq-answer').slideToggle();

		if ($(this).hasClass('opened')) {
			$(this).removeClass('opened');
			$(this).parent().removeClass('active');
		} else {
			$(this).toggleClass('opened');
			$(this).parent().addClass('active');
		}

		if ($(this).attr('aria-expanded') === 'true') {
			$(this).attr('aria-expanded', 'false');
		} else {
			$(this).attr('aria-expanded', 'true');
		}
	});
})(jQuery);
